module.exports = __webpack_public_path__ + "img/poster.6506b17d.png";